var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SellHeader',{attrs:{"img_header":_vm.header_image,"header":"คำสั่งซื้อใหม่","link_back":"sell/orderothermain"}}),_c('Create_order_other')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }